module.exports = __webpack_public_path__ + "img/gallery-nft-05.7749f742.png";